<template>
  <span :class="['peers-carousel', { 'sm': sm }]">
    <div>
      <div
        v-show="prev"
        @click="$emit('onClickPrev')"
        class="peers-carousel-navigation before"
      />
    </div>
    <div v-if="$deviceInfo.isMobile && 2 < carousel.count" class="d-flex justify-content-center peers-carousel-pagination">
      <span
        v-for="page in carousel.pages"
        :key="page"
        :class="['d-flex', 'pagination-item', { 'active': carousel.current === page}]"
        @click="changeCarousel(page)"/>
    </div>
    <div>
      <div
        v-show="next"
        @click="$emit('onClickNext')"
        class="peers-carousel-navigation next"
      />
    </div>
  </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PeersCarousel',
  props: {
    prev: Boolean,
    next: Boolean,
    sm: Boolean
  },
  computed: {
    ...mapGetters({
      carousel: 'roomPeers/carousel',
    })
  },
  methods: {
    ...mapActions({
      changeCarousel: 'roomPeers/changeCarousel'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.peers-carousel {
  position: absolute;
  top: 70%;
  right: 20px;
  left: 20px;
  display: flex;
  justify-content: space-between;

  @include mq(md) {
    top: 50%;
    right: 40px;
    left: 40px;
  }

  .peers-carousel-navigation {
    width: 50px;
    height: 50px;
    background: white;
    opacity: 0.5;
    border-radius: 50%;
    cursor: pointer;
    position: absolute;
    top: calc(50% - 25px);
    color: #707070;

    &:hover {
      opacity: 1;
    }

    &::before {
      content:  '';
      width: 12px;
      height: 12px;
      display:  block;
      border-top: solid 2px;
      border-right: solid 2px;
      position: absolute;
    }

    &.before {
      &::before {
        transform: rotate(225deg);
        top: calc(25px - 6px);
        left: calc(25px - 4px);
      }
    }

    &.next {
      right: 0;
      &::before {
        transform: rotate(45deg);
        top: calc(25px - 6px);
        left: calc(25px - 9px);
      }
    }
  }

  &.sm {
    position: relative;
    top: unset;
    right: unset;
    left: unset;
    width: 100%;
    height: 30px;

    .peers-carousel-navigation {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 20px;

      &::before {
        width: 8px;
        height: 8px;
        border-top: solid 2px;
        border-right: solid 2px;
      }

      &.before {
        left: 20px;
        &::before {
          top: calc(15px - 4px);
          left: calc(15px - 3px);
        }
      }

      &.next {
        right: 20px;
        &::before {
          top: calc(15px - 4px);
          left: calc(15px - 5px);
        }
      }
    }
  }

  .peers-carousel-pagination {
    width: calc(100vw - 240px);
    flex-wrap: wrap;

    .pagination-item {
      cursor: pointer;
      width: 10px;
      height: 10px;
      margin-right: 8px;
      margin-bottom: 8px;
      border-radius: 50%;
      background-color: #323232;

      &.active {
        background-color: #fff;
      }
    }
  }
}
</style>
